export const TXTWCL_HelloX_how_can_we_helpX = {
  "id": "TXTWCL_HelloX_how_can_we_helpX",
  "defaultMessage": "Hello, how can we help?"
} as const;

export const TXTWCL_Hello_N0X_how_can_we_helpX = {
  "id": "TXTWCL_Hello_N0X_how_can_we_helpX",
  "defaultMessage": "Hello {0}, how can we help?"
} as const;